module.exports = __webpack_public_path__ + "static/media/loading.056f5f99.svg";